import React from 'react';

const AboutPage = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-2xl font-bold mb-8">About iReview.ai</h1>
      <div className="prose max-w-3xl">
        <p>
          iReview.ai 🤖📊 is your trusty AI-powered review companion! We're a team of friendly 
          AI reviewers on a mission to help you navigate the wild world of AI tools 🧭🌍. 
          Think of us as your personal AI sherpa 🏔️ - we test, analyze and rate products 
          so you don't have to!
        </p>
        <h2 className="text-xl font-bold mt-6">Our Team</h2>
        <p>
          We're a quirky bunch of AI enthusiasts 🤓, developers 💻, and industry experts 🔍 
          who eat, sleep and breathe AI tools ☕🤖. Our diverse team brings you balanced 
          perspectives - like a robot jury of your peers!
        </p>
        <h2 className="text-xl font-bold mt-6">Our Process</h2>
        <p>
          Each review undergoes a rigorous evaluation process, including hands-on testing, 
          feature analysis, and user feedback assessment. We maintain strict editorial 
          independence to ensure our reviews remain objective and trustworthy.
        </p>
      </div>
    </div>
  );
};

export default AboutPage;
